@if (shouldShowLockScreen()) {
<div class="lock-screen">
  <div class="lock-screen-overlay"></div>
  
  <div class="lock-content">
    <!-- Time Display -->
    <div class="time-display">
      <span class="time">{{ currentTime() }}</span>
      <span class="date">{{ currentDate() }}</span>
    </div>

    <!-- User Avatar -->
    <div class="user-section">
      @if (userAvatar()) {
        <img [src]="userAvatar()" [alt]="userName() + ' profile photo'" [title]="userName() || 'User'" class="user-avatar" width="80" height="80" loading="lazy" />
      } @else {
        <div class="user-avatar-placeholder">
          <i class="fas fa-user"></i>
        </div>
      }
      <span class="user-name">{{ userName() }}</span>
    </div>

    <!-- Unlock Slider -->
    <div class="unlock-slider">
      <div class="slider-track" #sliderTrack>
        <div 
          class="slider-thumb"
          [class.unlocking]="isUnlocking()"
          [style.transform]="'translateX(' + dragOffset() + 'px)'"
          (mousedown)="onDragStart($event)"
          (touchstart)="onDragStart($event)"
          (pointerdown)="onDragStart($event)"
        >
          <!-- <i class="fas" [class.fa-lock]="!isUnlocking()" [class.fa-lock-open]="isUnlocking()"></i> -->
          <img src="/assets/icon.png" alt="Lock screen icon" title="Lock" class="lock-icon" width="20" height="20" loading="eager" />
        </div>
        <div class="slider-progress" [style.width.px]="dragOffset()"></div>
        <div class="slider-end">
          <i class="fas fa-unlock"></i>
        </div>
      </div>
      <p class="unlock-text">{{ isUnlocking() ? 'Release to unlock' : 'Slide to unlock' }}</p>
      <div class="slider-glow" [style.opacity]="dragProgress()"></div>
    </div>
  </div>

  <!-- Decorative Elements -->
  <div class="decorative-circles">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
    <div class="circle circle-3"></div>
  </div>
</div>
}

